// Public route — /terms. MA-09. DRAFT copy pending legal review.
import { createFileRoute } from "@tanstack/react-router";
import { LegalPage, LegalSection } from "@/components/LegalPage";

const LAST_UPDATED = "June 25, 2026";

function TermsPage() {
  return (
    <LegalPage title="Terms of Service" lastUpdated={LAST_UPDATED}>
      <LegalSection heading="About this beta">
        <p>
          PencilWise is early software offered to a small group of invited
          families. Features may change, break, or disappear while we test.
          Please don&apos;t rely on it as your only record of your child&apos;s
          learning.
        </p>
      </LegalSection>
      <LegalSection heading="Who can use it">
        <p>
          An account must be set up and managed by a parent or legal guardian who
          is 18 or older. The app is meant to be used by a child with that
          adult&apos;s involvement.
        </p>
      </LegalSection>
      <LegalSection heading="Your account">
        <p>
          You sign in with your Google account. You&apos;re responsible for
          keeping access to that account secure and for the activity under your
          PencilWise account.
        </p>
      </LegalSection>
      <LegalSection heading="Acceptable use">
        <p>
          Please use PencilWise only for your own family&apos;s learning.
          Don&apos;t try to break, copy, resell, or misuse the service.
        </p>
      </LegalSection>
      <LegalSection heading="No guarantees">
        <p>
          We work hard to make PencilWise helpful, but we provide it &ldquo;as
          is.&rdquo; We do not promise any particular learning result or outcome
          for your child.
        </p>
      </LegalSection>
      <LegalSection heading="Ending use">
        <p>
          You can stop using PencilWise and ask us to delete your data at any
          time. We may suspend or end access during the beta if needed.
        </p>
      </LegalSection>
      <LegalSection heading="Contact">
        <p>
          Questions about these terms? Email{" "}
          <a className="font-bold underline" href="mailto:support@pencilwise.app">
            support@pencilwise.app
          </a>
          .
        </p>
      </LegalSection>
    </LegalPage>
  );
}

export const Route = createFileRoute("/terms")({ component: TermsPage });
